import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { OrganizationPage } from "./organization/OrganizationPage";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { PrivateRoute } from "../../../PrivateRoute";
import { shallowEqual, useSelector } from "react-redux";
import { RoleChecker } from "../../../RoleChecker";
import { OrganizationDetail } from "./organization/organization-detail/OrganizationDetail";
import OrganizationFiles from "./organization/organization-file/OrganizationFiles";
import OrganizationCreate from "./organization/organization-create/OrganizationCreate";
import DashboardPage from "./dashboard/DashboardPage";
import { LibraryPage } from "./library/LibraryPage";
import { NotificationPage } from "./notification/NotificationPage";
import { NotificationTemplatePage } from "./notification-template/NotificationTemplatePage";
import NotificationTemplateForm from "./notification-template/notification-template-form/NotificationTemplateForm";
import { OrganizationReportPage } from "./organization-report/OrganizationReportPage";
import { ConsolidationReportPage } from "./consolidation-report/ConsolidationReportPage";
import { OrganizationFeaturePage } from "./organization-feature/OrganizationFeaturePage";
import { ConsolidationExportPage } from "./consolidation-export/ConsolidationExportPage";
import { ProgramReportPage } from "./program-report/ProgramReportPage";
import { OrganizationClassificationPage } from "./organization-classification/OrganizationClassificationPage";
import OrganizationReportDetail from "./organization-report/organization-report-detail/OrganizationReportDetail";
import { OrganizationRegionalPage } from "./organization-regional/OrganizationRegionalPage";
import OrganizationRegionalForm from "./organization-regional/organization-regional-form/OrganizationRegionalForm";
import { AccessRolePage } from "./access-role/AccessRolePage";
import { LogLoginPage } from "./log-login/LogLoginPage";
import AccessRoleForm from "./access-role/access-role-form/AccessRoleForm";
import { MasterDataUserPage } from "./master-data-user/MasterDataUserPage";
import { OrganizationCategoryPage } from "./organization-category/OrganizationCategoryPage";
import OrganizationCategoryForm from "./organization-category/organization-category-form/OrganizationCategoryForm";
import { RecapitulationReportPage } from "./recapitulation-report/RecapitulationReportPage";
import { OrganizationDeleteDataPage } from "./organization-delete-data/OrganizationDeleteDataPage";

export default function SuperAdminPage() {
  const { role } = useSelector(
    state => ({ role: state.auth.user.role }),
    shallowEqual
  );

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        {<Redirect exact from="/admin" to="/admin/organization" />}

        <PrivateRoute
          role={true}
          component={DashboardPage}
          path="/dashboard"
          exact={true}
        />

        {/* Organization Feature */}
        <PrivateRoute
          role={RoleChecker("Read", "organization_feature")}
          path="/admin/organization/feature"
          component={OrganizationFeaturePage}
        />

         {/* Organization Feature */}
         <PrivateRoute
          role={RoleChecker("Read", "organization_feature")}
          path="/admin/organization/delete-data"
          component={OrganizationDeleteDataPage}
        />

        {/* Organization */}
        <PrivateRoute
          role={RoleChecker("Read", "organization")}
          component={OrganizationPage}
          path="/admin/organization/register"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "organization")}
          component={OrganizationCreate}
          path="/admin/organization/-/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "organization")}
          component={OrganizationDetail}
          path="/admin/organization/:id/edit"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "organization")}
          component={OrganizationPage}
          path="/admin/organization/:value"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Read", "organization")}
          component={OrganizationFiles}
          path="/admin/organization/file/:id"
          exact={true}
        />

        {/* Library */}
        <PrivateRoute
          role={RoleChecker("Read", "library")}
          component={LibraryPage}
          path="/admin/library"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "library")}
          component={LibraryPage}
          path="/admin/library/:id/detail"
          exact={true}
        />

        {/* Organization Report */}
        <PrivateRoute
          role={RoleChecker("Read", "organization_report")}
          component={OrganizationReportPage}
          path="/admin/report/organization"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "organization_report")}
          component={OrganizationReportDetail}
          path="/admin/report/organization/:id/detail"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "organization_consolidation")}
          component={ConsolidationReportPage}
          path="/admin/report/consolidation"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Export", "organization_export_consolidation")}
          component={ConsolidationExportPage}
          path="/admin/report/export/consolidation"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Export", "organization_consolidation")}
          component={RecapitulationReportPage}
          path="/admin/report/recapitulation"
          exact={true}
        />

        {/* <PrivateRoute
          role={RoleChecker("Read", "program")}
          component={ProgramReportPage}
          path="/admin/report/program"
          exact={true}
        /> */}
        {/* SUPERADMIN NOTIFICATION */}
        <PrivateRoute
          role={RoleChecker("Read", "notification_organization")}
          component={NotificationPage}
          path="/admin/notification"
          exact={true}
        />
        {/* SUPERADMIN NOTIFICATION TEMPLATE */}
        <PrivateRoute
          role={RoleChecker("Read", "notification_template")}
          component={NotificationTemplatePage}
          path="/admin/template-notification"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "notification_template")}
          component={NotificationTemplateForm}
          path="/admin/template-notification/new"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "notification_template")}
          component={NotificationTemplateForm}
          path="/admin/template-notification/:id/edit"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Read", "master_data_classification")}
          component={OrganizationClassificationPage}
          path="/admin/master-data/classification-org"
          exact={true}
        />

        {/* Master Data Regional */}
        <PrivateRoute
          role={RoleChecker("Read", "master_data_regional")}
          component={OrganizationRegionalPage}
          path="/admin/master-data/regional"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "master_data_regional")}
          component={OrganizationRegionalForm}
          path="/admin/master-data/regional/create"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "master_data_regional")}
          component={OrganizationRegionalForm}
          path="/admin/master-data/regional/:id/edit"
          exact={true}
        />

        {/* Master Data Akses Role */}
        <PrivateRoute
          role={RoleChecker("Read", "master_data_access_role")}
          component={AccessRolePage}
          path="/admin/master-data/access-role"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "master_data_access_role")}
          component={AccessRoleForm}
          path="/admin/master-data/access-role/create"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "master_data_access_role")}
          component={AccessRoleForm}
          path="/admin/master-data/access-role/:id/edit"
          exact={true}
        />

        {/* Master Data Log Login */}
        <PrivateRoute
          role={RoleChecker("Read", "master_data_access_role")}
          component={LogLoginPage}
          path="/admin/master-data/log-login"
          exact={true}
        />

        {/* Master Data Category */}
        <PrivateRoute
          role={RoleChecker("Read", "master_data_category")}
          component={OrganizationCategoryPage}
          path="/admin/master-data/category"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Create", "master_data_category")}
          component={OrganizationCategoryForm}
          path="/admin/master-data/category/create"
          exact={true}
        />
        <PrivateRoute
          role={RoleChecker("Edit", "master_data_category")}
          component={OrganizationCategoryForm}
          path="/admin/master-data/category/:id/edit"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Read", "master_data_user")}
          component={MasterDataUserPage}
          path="/admin/master-data/user"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Create", "master_data_user")}
          component={MasterDataUserPage}
          path="/admin/master-data/user/create"
          exact={true}
        />

        <PrivateRoute
          role={RoleChecker("Edit", "master_data_user")}
          component={MasterDataUserPage}
          path="/admin/master-data/user/:id/edit"
          exact={true}
        />

        {/* DI HIDE DULU */}
        {/* <PrivateRoute
          role={true}
          component={OrganizationFilePage}
          path="/admin/_organization-file"
          exact={true}
        />
        <PrivateRoute
          role={true}
          component={OrganizationFileDetail}
          path="/admin/_organization-file/file"
          exact={true}
        /> */}
      </Switch>
    </Suspense>
  );
}
